import React from "react";
import cn from 'classnames';
import styles from "./tabs.css";

export const Indicator = (props) => {
    return (
        <div {...props} className={cn(styles.tabs_indicator, props.className)} />
    )
}